var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canShowEditor)?_c('div',{staticClass:"form-group"},[_c('ckeditor',{attrs:{"editor":_vm.editor,"config":_vm.editorConfig},model:{value:(_vm.iValue),callback:function ($$v) {_vm.iValue=$$v},expression:"iValue"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }